module.exports = __webpack_public_path__ + "static/img/CoTextCorp-Light.5e98803.svg";